import Header from "@/types/app/header";

export class ImportCompanyHeader {
  public static header: Header[] = [
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "name",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header",
      width: ""
    },   
    {
      text: "Country",
      align: "start",
      sortable: true,
      value: "country",
      class: "item-table-header",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}

export class ImportInvestorHeader {
  public static header: Header[] = [    
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "name",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" 
    }
  ];
}

export class ImportAccountHeader {
  public static header: Header[] = [
    
    {
      text: "Fund Name",
      align: "start",
      sortable: true,
      value: "fundName",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Account Number",
      align: "start",
      sortable: true,
      value: "accountNumber",
      class: "item-table-header",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" 
    }
  ];
}
